// removed by extract-text-webpack-plugin
module.exports = {"block":"_3YsvCP4XJ-Yg5t9QYj25KY","open":"_3kCfeYR6eucg-Cc9gAKtJb","yellow":"VVIWLvJwv6kmw4RYvz4bM","dropdown":"_2pwINaI7VAwJYoQalVG2mI","overlay":"_3QSMKkRwled7x-hPncJFFi","arrow":"_1XUNhNNY8yZwQ0HjSlAD3C","close":"_1cMfz4-f3cH3IQ6udJdjsG","dropdown-item":"_1iK0PyonUm-S-S5YQ0Z1bH","zebra":"_2Eq96kRUAl68uA1hxHcf1x","single":"zmfvtF9d1Rm1O4c1T-i1X","active":"_1WjLCeBfKKkDEW7IsO4V1a","dropdown-group":"_1Tz-Gqfk41PLOmKSH4Q0rz","dropdown-check":"_3tzDU_DoQOuiFHel9B_y3B","number":"_1w4Z7q6jB7iQ9ocrIJkw3t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownFilter/DropdownFilter.module.scss
// module id = 753
// module chunks = 0